// Fork from Three.js with updaten needed
/* eslint-disable @typescript-eslint/no-this-alias */
import { LinearFilter, Texture } from 'three';

class VideoTexture extends Texture {
    constructor(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);

        this.isVideoTexture = true;

        this.minFilter = minFilter !== undefined ? minFilter : LinearFilter;
        this.magFilter = magFilter !== undefined ? magFilter : LinearFilter;

        this.generateMipmaps = false;
        this.flipY = false;

        this.canUpdate = false;

        const scope = this;

        function updateVideo() {
            scope.needsUpdate = true;
            video.requestVideoFrameCallback(updateVideo);
        }

        if ('requestVideoFrameCallback' in video) {
            video.requestVideoFrameCallback(updateVideo);
        }
        this._isPlayable = undefined;
    }

    clone() {
        return new this.constructor(this.image).copy(this);
    }

    update() {
        if (!this.canUpdate) return;

        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;

        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) {
            this.needsUpdate = true;
        }
    }
}

export { VideoTexture };
